import { useState } from "react";
import { isTestEnquiry } from "./adminUtils";

const SEARCH_FIELDS = ["name", "email", "phone", "message", "note", "referred_by"];

// Owns the tab / search / class / source / replied filters and derives the visible list.
export function useEnquiryFilters(enquiries) {
  const [tab, setTab] = useState("enquiries"); // enquiries | tests
  const [hideReplied, setHideReplied] = useState(false);
  const [sourceFilter, setSourceFilter] = useState(null);
  const [classFilter, setClassFilter] = useState(null);
  const [query, setQuery] = useState("");

  const realEnquiries = enquiries.filter((e) => !isTestEnquiry(e));
  const testEnquiries = enquiries.filter(isTestEnquiry);
  const tabList = tab === "tests" ? testEnquiries : realEnquiries;

  const q = query.trim().toLowerCase();
  const matchesQuery = (e) => !q || SEARCH_FIELDS.some((k) => (e[k] || "").toLowerCase().includes(q));
  const matchesClass = (e) => !classFilter || (e.classes?.length ? e.classes : [e.program]).includes(classFilter);
  const matchesSource = (e) => !sourceFilter || e.heard_from === sourceFilter;
  const matchesReplied = (e) => !(hideReplied && e.replied);

  const activeList = tabList.filter((e) => matchesReplied(e) && matchesSource(e) && matchesClass(e) && matchesQuery(e));
  const hasFilters = !!(q || classFilter || sourceFilter || hideReplied);

  const clearFilters = () => {
    setQuery("");
    setClassFilter(null);
    setSourceFilter(null);
    setHideReplied(false);
  };
  const toggleClass = (c) => setClassFilter((prev) => (prev === c ? null : c));
  const toggleSource = (s) => setSourceFilter((prev) => (prev === s ? null : s));

  return {
    tab, setTab, hideReplied, setHideReplied, sourceFilter, setSourceFilter, classFilter, setClassFilter,
    query, setQuery, q, realEnquiries, testEnquiries, tabList, activeList, hasFilters, clearFilters, toggleClass, toggleSource,
  };
}
